import { Component, inject, input, viewChild } from '@angular/core';
import { ILpActivity } from '@gametailors/leerplus';
import { LpRidAlgoritmeActivity } from '../../../../typings/schema';
import { RidAlgorithm } from '../../../mechanics/rid-algorithm/rid-algorithm';
import { RidAssignmentBackground } from '../../components/rid-assignment-background/rid-assignment-background';
import { LEERPLUS } from '../../rid-game.utils';

@Component({
  selector: 'rid-algoritme-activity',
  imports: [RidAlgorithm, RidAssignmentBackground],
  templateUrl: './rid-algoritme-activity.html',
})
export class RidAlgoritmeActivity implements ILpActivity<LpRidAlgoritmeActivity> {
  private readonly $lpApiService = inject(LEERPLUS.apiToken);

  activity = input.required<LpRidAlgoritmeActivity>();

  private readonly algorithm = viewChild.required(RidAlgorithm);

  private isFinished = false;

  constructor() {
    this.$lpApiService.wizard.attach('algoritme');
    this.$lpApiService.wizard.registerCommand('skip-klankvoet', () => this.algorithm().skipKlankvoetPhase());
    this.$lpApiService.wizard.registerCommand('press-enter', async () => {
      const algorithm = this.algorithm();
      if (!algorithm.canOkay()) {
        console.warn(`[🪄] 'algoritme.press-enter' ignored: the enter button is currently disabled`);
        return;
      }

      await algorithm.okay();
    });
  }

  finish() {
    if (this.isFinished) return;

    this.isFinished = true;
    this.$lpApiService.finishCurrentActivity();
  }
}
